export default __webpack_public_path__ + "static/media/world-atlas-2-lqMAX.8a4e6055.jpg";